import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { ToggleInput } from "./ToggleInput";
import { HookFormToggleInputProps } from "./ToggleInput.types";

/** `ToggleInput` bound to a boolean react-hook-form field. */
export const HookFormToggleInput = <T extends FieldValues>(
  props: HookFormToggleInputProps<T>
): React.ReactElement => {
  const { form, name, rules, onChange, ...rest } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => (
        <ToggleInput
          {...rest}
          checked={!!field.value}
          onCheckedChange={(checked) => {
            field.onChange(checked);
            onChange?.(checked);
          }}
          error={
            fieldState.error?.message ||
            buildErrorMessageForName(form, name) ||
            undefined
          }
        />
      )}
    />
  );
};
